import { cn } from "@/src/lib/utils";
import { useState, useEffect } from "react";

export function Spinner({ className = "", size = 24, text }: { className?: string; size?: number; text?: string }) {
  const [svgError, setSvgError] = useState(false);
  const [show, setShow] = useState(false);

  // Ensure spinner is visible for at least 500ms to prevent flashing
  useEffect(() => {
    const timer = setTimeout(() => setShow(true), 0);
    return () => clearTimeout(timer);
  }, []);

  // For very small sizes, just show shimmer text without spinner
  const isVerySmall = size < 20;
  // For small sizes, don't show text (unreadable)
  const shouldShowText = text && size > 48;
  // Scale text size based on spinner size
  const textFontSize = Math.max(12, Math.min(24, size / 3));

  if (!show) {
    return (
      <div className={cn("flex flex-col items-center justify-center w-full py-8", className)} style={{ minHeight: size * 2 + 16 }} />
    );
  }

  // Very small: just shimmer text, no spinner
  if (isVerySmall) {
    return (
      <div className={cn("flex flex-col items-center justify-center w-full py-8", className)}>
        <div className="text-muted-foreground animate-pulse bg-gradient-to-r from-muted-foreground/50 via-muted-foreground to-muted-foreground/50 bg-clip-text text-transparent bg-[length:200%_100%] animate-shimmer">
          {text || "Loading..."}
        </div>
      </div>
    );
  }

  return (
    <div className={cn("flex flex-col items-center justify-center w-full py-8", className)}>
      {!svgError ? (
        <img
          src="/assets/loader.svg"
          alt="Loading"
          width={size * 2}
          height={size * 2}
          onError={() => setSvgError(true)}
          className="select-none"
        />
      ) : (
        <div className="text-muted-foreground animate-pulse">
          Loading...
        </div>
      )}
      {shouldShowText && (
        <div className="mt-4 text-center text-muted-foreground" style={{ fontSize: `${textFontSize}px` }}>
          {text}
        </div>
      )}
    </div>
  );
}
